
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const AccessDeniedComponent = lazy(() => import('../components/_error-pages/access-denied/AccessDeniedComponent'));
const ClientsComponent = lazy(() => import('../components/clients/ClientsComponent'));
const Campaigns = lazy(() => import('../components/campaigns'));
const Avails = lazy(() => import('../components/avails'));
const Markets = lazy(() => import('../components/markets/MarketList'));
const NetworksComponent = lazy(() => import('../components/networks/NetworksComponent'));
const AgencyCommissionComponent = lazy(() => import('../components/agency-commission/AgencyCommissionComponent'));
const Programme = lazy(() => import('../components/programme'));
const OrganisationComponent = lazy(() => import('../components/organisation/OrganisationComponent'));
const HomeComponent = lazy(() => import('../components/home/HomeComponent'));
const InternalServerComponent = lazy(() => import('../components/_error-pages/internal-server/InternalServerComponent'));
const NotFoundComponent = lazy(() => import('../components/_error-pages/not-found/NotFoundComponent'));
const MaintenanceComponent = lazy(() => import('../components/maintenance/MaintenanceComponent'));
const HelpComponent = lazy(() => import('../components/help/HelpComponent'));
const RequestTimeoutComponent = lazy(() => import('../components/_error-pages/request-timeout/RequestTimeoutComponent'));
const BusinessRulesComponent = lazy(() => import('../components/business-rules/BusinessRulesComponent'));
const BusinessRuleValuesComponent = lazy(() => import('../components/business-rule-values/BusinessRuleValuesComponent'));
const EmailTriggerComponent = lazy(() => import('../components/email-trigger/EmailTriggerComponent'));
const MarketComponent = lazy(() => import('../components/markets/MarketComponent'));
const StationComponent = lazy(() => import('../components/stations/StationComponent'));
const Booking = lazy(() => import('../components/booking'));
const DemographicsComponent = lazy(() => import('../components/demographics/DemographicsNew'));
const ContactComponent = lazy(() => import('../components/contact/ContactComponent'));
const CreativesComponent = lazy(() => import('../components/creatives/CreativesComponent'));
const InstructionsComponent = lazy(() => import('../components/instrucstions/InstructionsComponent'));
const OrderComponent = lazy(() => import('../components/orders/all-orders/OrderComponent'));
const InvoicesComponent = lazy(() => import('../components/invoices/InvoicesComponent'));
const Op2miseWidgetStudioComponent = lazy(() => import('../components/ows/Op2miseWidgetStudio'));
const ReachParameterComponent = lazy(() => import('../components/reach-parameter/ReachParameterComponent'));
const OrdersWithoutInvoiceComponent = lazy(() => import('../components/orders/orders-without-invoice/OrdersWithoutInvoiceComponent'));
const OrdersWithoutTrafficComponent = lazy(() => import('../components/orders/orders-without-traffic/OrdersWithoutTrafficComponent'));
const OrdersVersionHistoryComponent = lazy(() => import('../components/orders/orders-version-history/OrdersVersionHistoryComponent'));
const ActiveAvailInventoryComponent = lazy(() => import('../components/avails/active/ActiveAvailInventoryComponent'));
const ArchivedAvailInventoryComponent = lazy(() => import('../components/avails/archived/ArchivedAvailInventoryComponent'));

class ViewsRouter {
  routes = [
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/`,
      element: <HomeComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/not-found`,
      element: <NotFoundComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/access-denied`,
      element: <AccessDeniedComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/campaigns`,
      element: <Campaigns />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/avails`,
      element: <Avails />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/avails/inventories`,
      element: <ActiveAvailInventoryComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/avails/inventories/archived`,
      element: <ArchivedAvailInventoryComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/bookings/:campId/:marketId`,
      element: <Booking />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/markets`,
      element: <Markets />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/programme`,
      element: <Programme />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/data-management/clients`,
      element: <ClientsComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/data-management/markets`,
      element: <MarketComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/data-management/networks`,
      element: <NetworksComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/data-management/stations`,
      element: <StationComponent />,
    },
    {
     path: `${process.env.REACT_APP_SUBFOLDER}/data-management/demographics`,
     element: <DemographicsComponent />,
    },
    {
     path: `${process.env.REACT_APP_SUBFOLDER}/agency-commission`,
     element: <AgencyCommissionComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/organisations`,
      element: <OrganisationComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/business-rules`,
      element: <BusinessRulesComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/custom-business-rules`,
      element: <BusinessRuleValuesComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/email-trigger`,
      element: <EmailTriggerComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/contacts`,
      element: <ContactComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/trafficking/creatives`,
      element: <CreativesComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/trafficking/instructions`,
      element: <InstructionsComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/invoices`,
      element: <InvoicesComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/orders`,
      element: <OrderComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/orders-without-invoice`,
      element: <OrdersWithoutInvoiceComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/orders-without-traffic`,
      element: <OrdersWithoutTrafficComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/orders-version-history`,
      element: <OrdersVersionHistoryComponent />
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/reach-parameter`,
      element: <ReachParameterComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/internal-server/:message`,
      element: <InternalServerComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/help`,
      element: <HelpComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/maintenance`,
      element: <MaintenanceComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/request-timeout`,
      element: <RequestTimeoutComponent />,
    },
    {
      path: `${process.env.REACT_APP_SUBFOLDER}/ows`,
      element: <Op2miseWidgetStudioComponent />
    },
    {
      path: '*',
      element: <Navigate to={`${process.env.REACT_APP_SUBFOLDER}/not-found`} />,
    },
  ];
}

const viewsRouter = new ViewsRouter();
export default viewsRouter;
